/*
  Home page rows: behaviour moved out of the row snippets.
  Loaded (defer) from layout/theme.liquid on the home page and the About page.
  - Paging for every [data-scroller] (product rows, reviews row)
  - Recently Viewed swap for product rows marked is-rv-pending by their inline pre-paint check
  - "Add setup to cart" for [data-home-setups]
*/
(function(){
  // ---------- Paging: one handler for every [data-scroller] ----------
  function initScroller(root){
    const track = root.querySelector('[data-scroller-track]');
    const prev = root.querySelector('[data-scroller-prev]');
    const next = root.querySelector('[data-scroller-next]');
    const nav = root.querySelector('[data-scroller-nav]');
    if (!track || !prev || !next || !nav) return null;

    // One "page" = the visible card area plus the gap; the track's side padding (reviews: 4px focus-ring frame) is taken off
    const pageWidth = () => {
      const cs = getComputedStyle(track);
      return track.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) + (parseFloat(cs.columnGap) || 0);
    };

    function update(){
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      nav.hidden = max <= 2;
    }

    prev.addEventListener('click', () => track.scrollBy({ left: -pageWidth() }));
    next.addEventListener('click', () => track.scrollBy({ left: pageWidth() }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    return { track, update };
  }

  // ---------- Recently Viewed swap (product rows) ----------
  function initRecentlyViewed(root, scroller){
    // Only armed when the inline pre-paint check found enough history
    if (!root.classList.contains('is-rv-pending')) return;
    const done = () => root.classList.remove('is-rv-pending');
    if (!scroller) return done();
    const { track, update } = scroller;
    let list = [];
    try { list = JSON.parse(localStorage.getItem('cfs_rv')) || []; } catch (e) {}
    if (!Array.isArray(list)) return done();
    const min = parseInt(root.dataset.rvMin, 10) || 2;
    const limit = parseInt(root.dataset.rvLimit, 10) || 8;
    const rootUrl = root.dataset.rootUrl || '/';
    const ctrl = window.AbortController ? new AbortController() : null;
    let settled = false;
    const timer = setTimeout(() => { settled = true; if (ctrl) ctrl.abort(); done(); }, 3000);

    const fetchCard = (entry) => {
      if (!entry || typeof entry.h !== 'string' || !entry.h) return Promise.resolve(null);
      const url = rootUrl.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(entry.h) + '?view=home-card';
      return fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'same-origin' })
        .then((r) => (r.ok && r.status === 200 ? r.text() : ''))
        .then((html) => {
          if (!html || !html.trim()) return null;
          const tpl = document.createElement('template');
          tpl.innerHTML = html;
          return tpl.content.querySelector('li.hc-card');
        })
        .catch(() => null);
    };

    Promise.all(list.slice(0, limit).map(fetchCard)).then((cards) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      cards = cards.filter(Boolean);
      if (cards.length >= min) {
        // Hold the row's height: fetched cards can have shorter text than the ones they replace
        track.style.minHeight = track.offsetHeight + 'px';
        window.addEventListener('resize', () => { track.style.minHeight = ''; }, { once: true });
        track.replaceChildren(...cards);
        // Ship day, label fit and row labels for the new cards (assets/product-card.js)
        window.cfsCards && window.cfsCards.refresh(track);
        const title = root.querySelector('.wwl__title');
        if (title && root.dataset.rvTitle) title.textContent = root.dataset.rvTitle;
        const all = root.querySelector('.wwl__all');
        if (all) all.hidden = true;
        root.dataset.rowMode = 'recently-viewed';
        track.scrollLeft = 0;
        update();
      }
      done();
    });
  }

  // ---------- Setups: add the setup bundle to the cart ----------
  function initSetups(section){
    if (section.dataset.bound) return;
    section.dataset.bound = '1';

    const cartAdd = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add'
      : section.dataset.cartAddUrl) + '.js';

    section.addEventListener('click', function(e){
      var btn = e.target.closest('[data-setup-add]');
      if (!btn || !section.contains(btn) || btn.getAttribute('aria-busy') === 'true') return;

      var label = btn.querySelector('[data-setup-label]');
      var error = btn.parentNode.querySelector('.home-setups__error');
      var properties = {};
      try { properties = JSON.parse(btn.dataset.properties || '{}'); } catch (err) {}

      function done(){
        btn.removeAttribute('aria-busy');
        label.textContent = section.dataset.labelAdd;
      }

      if (error) error.hidden = true;
      btn.setAttribute('aria-busy', 'true');
      label.textContent = section.dataset.labelAdding;

      fetch(cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: properties }] })
      })
        .then(function(r){
          if (!r.ok) throw new Error('cart add ' + r.status);
          done();
          window.cdfRefreshCart?.({ open: true });
        })
        .catch(function(){
          done();
          if (error) error.hidden = false;
        });
    });
  }

  function init(){
    document.querySelectorAll('[data-scroller]').forEach((root) => {
      const scroller = initScroller(root);
      if (root.classList.contains('wwl')) initRecentlyViewed(root, scroller);
    });
    document.querySelectorAll('[data-home-setups]').forEach(initSetups);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
